<template>
    <PopupRouterView :showLeftIcon="true" label="Document Status Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="documentstatus"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="documentStatusInput">


        <b-card header="Document Status" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name"   />
						<app-input-textbox id="fieldset-sequence" label-cols-lg="12"  label="Sequence" label-for="input-sequence" size="sm" type="number" :model.sync="model.sequence"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusList from '@/models/DocumentStatus/DocumentStatusList';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDocumentStatus : null,
			currentDocumentStatusPage : 1,
			documentStatusPageSize: 10,
			sortByDocumentStatus: '',
			sortDescDocumentStatus: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDocumentStatus : async function(id) {
			this.isBusy = true;
			DocumentStatus.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDocumentStatus = true;
			this.filterDocumentStatus.id = this.modelId;
			DocumentStatus.downloadDataDetail(this, this.filterDocumentStatus).then(result => {
				this.isDownloadDocumentStatus = false;
			}).catch(error => { this.isDownloadDocumentStatus = false; })
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.documentStatusInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						DocumentStatus.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'documentstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						DocumentStatus.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'documentstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DocumentStatus.updateData(this, model, id)
					.catch((error) => {
						this.getDocumentStatus(id);
					});
				}
			});
		},
		onHidden() {
			this.getDocumentStatuss();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDocumentStatus = new DocumentStatusFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDocumentStatus(id);
			} else {
				this.modelId = id;
				this.getDocumentStatus(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
